import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, ArrowRight } from "lucide-react";
import { WaitlistModal } from "./WaitlistModal";

export const FounderBar = () => {
  const [show, setShow] = useState(false);
  const [dismissed, setDismissed] = useState(
    () => typeof window !== "undefined" && localStorage.getItem("tq_founderbar_dismissed") === "1"
  );
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > window.innerHeight * 0.9);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const close = () => {
    setDismissed(true);
    localStorage.setItem("tq_founderbar_dismissed", "1");
  };

  const visible = show && !dismissed && !open;

  useEffect(() => {
    document.documentElement.toggleAttribute("data-founderbar-reserve", !dismissed);
    return () => document.documentElement.removeAttribute("data-founderbar-reserve");
  }, [dismissed]);

  useEffect(() => {
    const wrap = document.querySelector(".crt-toggle-wrap");
    if (wrap) wrap.style.bottom = visible ? "5rem" : "";
    document.documentElement.setAttribute("data-founderbar", visible ? "open" : "closed");
    return () => {
      const w = document.querySelector(".crt-toggle-wrap");
      if (w) w.style.bottom = "";
      document.documentElement.setAttribute("data-founderbar", "closed");
    };
  }, [visible]);

  return (
    <>
      <AnimatePresence>
        {visible && (
          <motion.div
            data-testid="founder-bar"
            initial={{ y: 80, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 80, opacity: 0 }}
            transition={{ type: "spring", stiffness: 320, damping: 30 }}
            className="fixed bottom-0 left-0 right-0 z-[70] border-t border-white/[0.10] bg-[#0A0A0A]/95 backdrop-blur-xl"
          >
            <div className="mx-auto max-w-[1400px] px-4 sm:px-6 md:px-12 py-2.5 flex items-center gap-3 sm:gap-5">
              <span className="hidden sm:flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-[0.25em] text-[#B4BAC4] whitespace-nowrap">
                <span className="h-1.5 w-1.5 rounded-full bg-[#BACD1C] animate-pulse" /> Founder access
              </span>
              <p className="min-w-0 flex-1 font-mono text-[11px] sm:text-xs text-white/60 truncate">
                The Quant Terminal is opening early to founders —{" "}
                <span className="text-white/90">claim your spot before public launch.</span>
              </p>
              <button
                onClick={() => setOpen(true)}
                data-testid="founder-bar-cta"
                className="shrink-0 inline-flex items-center gap-1.5 bg-[#BACD1C] text-black font-mono text-[11px] sm:text-xs uppercase tracking-[0.12em] px-3.5 sm:px-5 py-2 hover:bg-white active:scale-95 transition-[background-color,transform] duration-300 whitespace-nowrap"
              >
                Create free account <ArrowRight size={14} />
              </button>
              <button
                onClick={close}
                data-testid="founder-bar-close"
                aria-label="Dismiss"
                className="shrink-0 text-white/35 hover:text-white transition-colors"
              >
                <X size={16} />
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
      <AnimatePresence>
        {open && <WaitlistModal open={open} onClose={() => setOpen(false)} />}
      </AnimatePresence>
    </>
  );
};
